export default (function (value) {
  return typeof value === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isFunction.js
// module id = 357
// module chunks = 35